"use client";

export { default as SkillzStyle } from "SkillzStyle"